<template>
  <li class="nav-item dropdown">
    <a
      id="dropdownMenuTrigger"
      class="nav-link dropdown-toggle mx-xl-3 dropdown-menu-trigger"
      href="#"
      data-bs-toggle="dropdown"
      data-bs-auto-close="outside"
      >{{ title }}</a
    >
    <ul class="dropdown-menu shadow-navbar-custom-ff fs-nav-custom-ff" id="dropdownMenu" aria-labelledby="dropdownMenuTrigger">
      <div class="row" :class="right.length>0?'third-level-nav':''">
        <div class="col-12" :class="right.length>0?'col-xl-6 pe-0-nav-custom-ff':''" :style="{borderRight: right.length>0?'1px solid white':''}">
          <SecondLayer
            v-for="(child, index) in left"
            :key="'lchild-' + index"
            :title="child.title"
            :href="child.url"
            :hasChild="child.hasChild"
            :childs="child.childs"
            :total="left.length-1"
            :left="true"
            :countChildRight="right.length"
            :countChildLeft="left.length"
            :width="width"
            :_index="index"
            :indexParent="indexParent"
          />
        </div>
        <div class="col-xl-6 ps-0-nav-custom-ff" v-if="right.length>0">
          <SecondLayer
            v-for="(child, index) in right"
            :key="'rchild-' + index"
            :title="child.title"
            :href="child.url"
            :hasChild="child.hasChild"
            :childs="child.childs"
            :total="right.length-1"
            :left="false"
            :countChildRight="right.length"
            :countChildLeft="left.length"
            :width="width"
            :_index="index"
            :indexParent="indexParent"
          />
        </div>
      </div>
    </ul>
  </li>
</template>

<script>
import SecondLayer from "@/Components/Menu/SecondLayer";
export default {
  components: {
    SecondLayer,
  },
  props: {
    title: String,
    isTheUrl: Boolean,
    href: String,
    hasChild: Boolean,
    childs: Array,
    width: Number,
    indexParent: Number,
  },
  computed: {
    left() {
      return this.childs.filter(
        (item, index) => index < Math.ceil(this.childs.length / 2)
      );
    },
    right() {
      return this.childs.filter(
        (item, index) => index >= Math.ceil(this.childs.length / 2)
      );
    },
  },
};
</script>

<style>
</style>
